<template>
    <div
        :class="[
            isOpen ? 'right-0' : '-right-[1124px] lg:-right-[650px]',
            // h-screen here breaks header on mobile safari, fixed to avoid animation bug
            'fixed bottom-0 lg:max-w-[492px] w-[492px] h-full flex flex-col z-50 lg:z-0',
            'bg-white transform transition-all duration-500 ease-in-out max-w-full min-w-full lg:min-w-[492px]',
        ]"
    >
        <div
            id="cz3__toast-anchor-top"
            class="absolute top-[16px] left-[20px] right-[20px] lg:left-[40px] lg:right-[40px] z-[70] pointer-events-none"
        >
            <toast-anchor anchor-name="top" />
        </div>
        <header class="sticky px-[20px] lg:px-[40px] flex justify-between items-center border-b border-gray-DFDFDF text-base h-[64px]">
            <!-- <div class="block lg:hidden underline mt-2 mr-16">Reset</div> -->
            <slot name="header" />
        </header>

        <div
            ref="optionsList"
            class="flex-1 flex flex-col min-h-0 overflow-y-auto overflow-x-hidden bg-white"
            style="transform: translateZ(0);"
        >
            <slot name="content" v-if="localIsOpen || showGroupOverlay" />

            <slot name="footer" />
        </div>
    </div>
</template>

<script>
    import allStores from '../stores/all';
    import ToastAnchor from './ToastAnchor.vue';

    export default {
        mixins: [allStores],

        components: {
            ToastAnchor,
        },

        emits: ['overlayClose'],

        props: {
            isOpen: {
                type: Boolean,
                required: true,
            },
            showColorControls: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                localIsOpen: false,
            };
        },

        watch: {
            isOpen(isOpen) {
                if (isOpen) {
                    this.localIsOpen = isOpen;
                } else {
                    setTimeout(() => {
                        this.localIsOpen = isOpen;
                    }, 250); // Delay for animation
                }
            },
        },

        computed: {
            isMobile() {
                return this.appStore?.isMobile;
            },

            showRenderer() {
                if (!this.isMobile) {
                    return false;
                }

                if (this.shouldShowViewAll) {
                    return false;
                }

                const integratedFrontGroupNames = ['Face/Sole', 'Character Stamping', 'Stamps'];

                if (integratedFrontGroupNames.includes(this.currentGroupName)) {
                    return this.customizerStore.isFrontSectionActive('paintfill')
                        || this.customizerStore.isFrontSectionActive('stamps')
                        || this.customizerStore.isFrontSectionActive('initials');
                }

                if (this.currentGroupName === 'Top') {
                    return this.customizerStore.isTopSectionActive();
                }

                if (this.currentGroupName === 'Back') {
                    return this.customizerStore.isBackSectionActive('back');
                }

                return false;
            },

            currentGroupName() {
                return this.customizerStore.currentGroup;
            },

            shouldShowViewAll() {
                return this.appStore.shouldShowViewAll;
            },

            isFullscreen() {
                return this.appStore.isFullscreen;
            },

            showGroupOverlay() {
                return this.appStore.showGroupOverlay;
            },
        },

        methods: {
            setShouldShowSummary(value) {
                this.appStore.setShouldShowSummary(value);
            },

            async emitClose() {
                this.$emit('overlayClose');
                this.customizerStore.clearCurrentGroup();
                this.appStore.scrollPanelToTop();
                await new Promise((resolve) => { setTimeout(resolve, 250); });
                this.setShouldShowSummary(false);
            },
        },
    };
</script>

<style scoped>
    .cz3__overlay-renderer-shell {
        overflow: hidden;
    }

    .cz3__overlay-renderer-area-enter-active,
    .cz3__overlay-renderer-area-leave-active {
        transition:
            max-height 320ms cubic-bezier(0.22, 1, 0.36, 1),
            opacity 240ms ease,
            transform 240ms ease;
        will-change: max-height, opacity, transform;
    }

    .cz3__overlay-renderer-area-enter-from,
    .cz3__overlay-renderer-area-leave-to {
        max-height: 0;
        opacity: 0;
        transform: translateY(-16px);
    }

    .cz3__overlay-renderer-area-enter-to,
    .cz3__overlay-renderer-area-leave-from {
        max-height: 200px;
        opacity: 1;
        transform: translateY(0);
    }
</style>
